export default "__VITE_ASSET__a84452c0__"